export default {
  root: "/",
  login: "/login",
  myPage: "/my-page",
  myTeam: "/my-team",
  hrPortal: "/hr-portal",
};
